import { HttpService } from '../../services/HttpService';
import { store } from '../../configureStore';
import { apiUrls } from '../../constants/apiUrl';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { setSession } from './Helpers';
import { CART_CONTACT_INFO_INTG } from './Helpers/constants';


const CallCradleAPI = (cradlePageName, currPageName) => {
  try {
    const postData = {
      properties: [{ name: 'pageName', value: cradlePageName }],
    };

    const apiURL = `${getSecureBaseUrl()}${apiUrls().cradleApi}`;
    const apiResponse = HttpService.post(apiURL, postData);
    Promise.all([apiResponse]).then((res) => {
      if (res[0] && res[0].data && res[0].status === 200) {
        setSession('CradleResponse', 'Y');
        const throttleList = res?.[0]?.data?.throttleList || '';
        if (throttleList?.includes('FWA_Signin_T_Prompt_P')) {
          setTimeout(() => {
            const signInPromt = document.querySelectorAll('#fwa_signin_prompt_overlay');
            signInPromt.forEach((ele) => {
              const element = ele;
              element.style.display = 'none';
            });
          }, 3000);
        }
        switch (currPageName) {
          case 'cart':
          case 'expresscheckout':
            setSession(CART_CONTACT_INFO_INTG, throttleList?.includes('FWA_Cart_T_ContactInfo') ? 'Y' : 'N');
            break;
          case 'contactinfo':
            if (throttleList?.includes('FWA_Skip_T_Registration')) {
              setSession('skipReg', 'Y');
            }
            break;

          case 'shipping':
            if (throttleList?.includes('FWA_T_ServiceAddressDisplay')) {
              setSession('serviceAddressDisplay', 'Y');
            }
            store.dispatch({ type: 'SHIPPING_THROTTLE_VALUE', response: throttleList });
            break;

          default:
            break;
        }

        store.dispatch({ type: 'SIGNIN_CRADLE_VALUE', response: throttleList });
        store.dispatch({ type: 'CRADLE_API_COMPLETED', response: true });
        store.dispatch({ type: 'STORE_CRADLE_THROTTLE_VALUE', response: throttleList });
      }
    });
  } catch (error) {
    // error block
  }
};
export default CallCradleAPI;
